const GUEST_TICKET_DISMISSED_KEY = 'lockedin_guest_ticket_dismissed';

export function isGuestWelcomeTicketDismissed() {
  try {
    return window.localStorage.getItem(GUEST_TICKET_DISMISSED_KEY) === 'true';
  } catch (_) {
    return false;
  }
}

export function persistGuestWelcomeTicketDismissed() {
  try {
    window.localStorage.setItem(GUEST_TICKET_DISMISSED_KEY, 'true');
  } catch (_) {}
}
